import script from "./ColourRangeComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ColourRangeComponent.vue?vue&type=script&setup=true&lang=js"

import "./ColourRangeComponent.vue?vue&type=style&index=0&id=1c9ab8eb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c9ab8eb"]])

export default __exports__